const M = require('M')

module.exports = {
  onMount() {
    const el = this.getEl('collapsible')
    this.collapsible = M.Collapsible.init(el, {})
  },
}
